import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import type { WalletHomeResponse } from '../models';
import { WalletHomeApi } from '../apis';

/**
 * WalletService
 *
 * Service layer that wraps WalletHomeApi.
 *
 * Responsibilities:
 * - Business logic and data transformations for wallet home data
 * - Abstraction layer between WalletStore and the HTTP layer
 * - Keeps stores free of direct API dependencies
 *
 * Architecture: Component → Store → Service → Api → Backend
 */
@Injectable({
  providedIn: 'root',
})
export class WalletService {
  private readonly walletHomeApi = inject(WalletHomeApi);

  /**
   * Fetch the full wallet home payload.
   *
   * @param page  - Page number for the transaction section (default: 1)
   * @param limit - Max transactions to return (default: 10)
   * @returns Observable<WalletHomeResponse>
   */
  getWalletHome(page = 1, limit = 10): Observable<WalletHomeResponse> {
    return this.walletHomeApi.getWalletHome(page, limit);
  }
}
